import { SiteConfig } from "@/interfaces/site_config";
import type { Store, MutationTree } from "vuex";
import { State } from "../state";
import { SiteConfigState } from "./state";
import { Settings } from "luxon";

export const mutations: MutationTree<SiteConfigState> = {
  setSiteConfigs(state: SiteConfigState, siteConfigs: SiteConfig[]): void {
    state.siteConfigurations = siteConfigs;
    state.siteConfigurationsLoaded = true;
  },
  setProjectTimeZone(state: SiteConfigState, timeZone: string): void {
    state.projectTimeZone = timeZone;
    state.projectTimeZoneLoaded = true;
    // Set the default timezone for Luxon.
    // Must await to ensure datetime objects aren't created before the timezone is set.
    // If waiting for the site config is too slow, we can try to set the
    // timezone on each construction of a datetime object.
    Settings.defaultZone = timeZone;
  },
  setDemoMode(state: SiteConfigState, demoMode: boolean): void {
    state.demoMode = demoMode;
  },
  setAssuresrvVersion(
    state: SiteConfigState,
    assuresrvVersion: string | null,
  ): void {
    state.assuresrvVersion = assuresrvVersion;
  },
  setSpectrogramBaselineDays(
    state: SiteConfigState,
    baselineDays: number,
  ): void {
    state.spectrogramBaselineDays = baselineDays;
  },
};

const NS = "siteConfig/";

export const commitSetSiteConfigs = (
  store: Store<State>,
  siteConfigs: SiteConfig[],
): void => {
  store.commit(`${NS}setSiteConfigs`, siteConfigs);
};

export const commitSetProjectTimeZone = (
  store: Store<State>,
  timeZone: string,
): void => {
  store.commit(`${NS}setProjectTimeZone`, timeZone);
};

export const commitSetDemoMode = (
  store: Store<State>,
  demoMode: boolean,
): void => {
  store.commit(`${NS}setDemoMode`, demoMode);
};

export const commitSetAssuresrvVersion = (
  store: Store<State>,
  assuresrvVersion: string | null,
): void => {
  store.commit(`${NS}setAssuresrvVersion`, assuresrvVersion);
};

export const commitSetSpectrogramBaselineDays = (
  store: Store<State>,
  baselineDays: number,
): void => {
  store.commit(`${NS}setSpectrogramBaselineDays`, baselineDays);
};
